import type { CiamEnvironment, JwtErrorCode } from '@portals/shared/common/utils';
import { decodeJwt, getCiamEnvironment } from '@portals/shared/common/utils';
import { useMemo } from 'react';

function getRequiredAudience(liveMode: boolean): CiamEnvironment {
  if (ENVIRONMENT_NAME === 'prod' && liveMode) return 'PROD';
  return 'TEST';
}

type Options = {
  errors: JwtErrorCode[];
  liveMode: boolean | undefined;
  token: string;
};

export function useJwtEnvironmentMismatch({ errors, liveMode, token }: Options): boolean {
  return useMemo(() => {
    if (!token || liveMode === undefined || errors.length > 0) {
      return false;
    }

    try {
      const { payload } = decodeJwt(token);
      const aud = Array.isArray(payload.aud) ? payload.aud[0] : payload.aud;
      if (!aud) {
        return false;
      }
      const jwtEnvironment = getCiamEnvironment(aud);
      return jwtEnvironment !== null && jwtEnvironment !== getRequiredAudience(liveMode);
    } catch {
      return false;
    }
  }, [errors, liveMode, token]);
}
